import { useCallback } from 'react'
import { useReactiveVar } from '@apollo/client'
import { useLocation, useNavigate } from 'react-router-dom'

import { matchedProductVar } from 'modulesCommon/store'
import { useLoading, useServerError } from 'shared/hooks'

import { useUpdateProduct } from 'modules/Artists/graphql/mutations'
import { IGCDMProduct } from 'shared/interfaces'
import { useDeleteNotification } from './useDeleteNotifications'

export const useMatchNotifications = () => {
  const matchedProduct = useReactiveVar(matchedProductVar)

  const { pathname } = useLocation()
  const navigate = useNavigate()

  const { onDeleteNotifications } = useDeleteNotification()
  const { mutate: updateProduct, loading: updateProductLoading, error: updateProductError } = useUpdateProduct()

  const onDeleteHandler = useCallback(() => {
    if (matchedProduct) {
      onDeleteNotifications([
        { id: matchedProduct.id, notification_type: matchedProduct.notification_type }
      ])
      matchedProductVar(null)
    }
  }, [matchedProduct, onDeleteNotifications])

  const onUpdateDvId = useCallback(
    (product: IGCDMProduct) => {
      updateProduct({
        variables: {
          input: {
            id: matchedProduct?.parent_id ?? '',
            dv_entity_id: product.dv_entity_id,
            dv_group_id: product.dv_group_id,
            gpid_list: product.gpid_list,
            name: matchedProduct?.name,
            configuration: matchedProduct?.configuration
          }
        }
      })
        .then(() => {
          if (matchedProduct) matchedProductVar({ ...matchedProduct, assignedGridList: product.gpid_list })
        })
        .then(() => {
          if (!matchedProduct?.assignedGridList) {
            onDeleteNotifications([
              { id: matchedProduct?.id, notification_type: matchedProduct?.notification_type }
            ])
          }
        })
    },
    [updateProduct, matchedProduct, onDeleteNotifications]
  )

  const openMatchedNotification = useCallback((product) => {
    matchedProductVar(product)
    if (pathname.includes('/globalhub')) {
      navigate('/feed')
    }
  }, [pathname, navigate])

  const onClearMatchedProduct = useCallback(() => matchedProductVar(null), [])
  useLoading({
    isLoading: updateProductLoading
  })
  useServerError([updateProductError])

  return {
    matchedProduct,
    openMatchedNotification,
    onClearMatchedProduct,
    onUpdateDvId,
    onDeleteHandler
  }
}
